<template>
  <div class="device-block-page">
    <div class="container">
      <div class="chart-block">
        <!-- <img src="/static/images/device/gzhz.png" class="titl"> -->
        <div class="item">
          <div class="chart-box">
            <v-chart :options="options_gzhz" />
            <div class="tab-switch">
              <span v-for="item in tabData" :class="[{'current': tabKey==item}]" v-text="item" @click="tabSwitch(item)"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts/lib/echarts'
export default{
  data() {
    let tabData = ['日', '周', '月'];
    return {
      tabData: tabData,
      tabKey: tabData[0],
      gzhzList: [],
      options_gzhz: {},
    }
  },
  mounted() {
    //定义全局方法
    window.gbfc_resetData = this.resetData;
    //初始化
    this.$initPage(this);
  },
  methods: {
    resetData() {
      //故障汇总
      this.getGzhzList();
    },
    tabSwitch(item) {
      console.log(item)
      this.tabKey = item;
      this.getGzhzList();
    },
    getGzhzList() {
      let self = this;
      let todayTime = (new Date(new Date().setHours(0, 0, 0, 0)).getTime()) / 1000;  //今天0点时间戳毫秒
      let startTime = this.$formatDateTime(todayTime - 3600*24, 'yyyy-MM-dd hh:mm:ss');
      let endTime = this.$formatDateTime(todayTime, 'yyyy-MM-dd hh:mm:ss');

      if(this.tabKey == '日') {
        //
      } else if(this.tabKey == '周') {
        startTime = this.$formatDateTime(todayTime - 3600*24*7, 'yyyy-MM-dd hh:mm:ss');
      } else if(this.tabKey == '月') {
        startTime = this.$formatDateTime(todayTime - 3600*24*30, 'yyyy-MM-dd hh:mm:ss');
      }
      console.log('--', startTime, endTime)
      let url = '/InteractAPI/FailureDistribution_Stn_Times/'+startTime+'/'+endTime;
      this.$handleRequest(window.ApiHost2+url, {}, 'get', function(res) {  //success
        self.gzhzList = res;
        /*console.log('--res--', res)
        res.forEach( function(r, ri) {
          self.gzhzList.push({value: res[key], name: key})
        });
        for(let key in res) {
          self.gzhzList.push({value: res[key], name: key})
        }*/
        self.setOptionsGzhz();
      }, function(res) {  //fail
        console.log('fail', res);
      });
    },
    setOptionsGzhz() {
      let colors = this.$charts.colors.style_2;
      let chartsConf = this.$charts[window.CurrentTheme];
      let sdata = [];
      let legendData = [];

      this.gzhzList.forEach( function(l, li) {
        legendData.push(l.StationName);
        let color = colors[li][1];
        let tmp = {
          value: l.TotalTime_Stn,
          name: l.StationName,
          label: {
            color: chartsConf.series.color,
            fontSize: 24
          },
          itemStyle:{
            normal:{
              color: color,
            }
          }
        };
        sdata.push(tmp);
      });
      this.options_gzhz = {
        tooltip : {
            trigger: 'item',
            formatter: "{b} : {c}次 ({d}%)",
            textStyle: {
              fontSize: 24
            }
        },
        legend: {
            x : 'center',
            y : 'bottom',
            textStyle: {
              color: chartsConf.legend.color,
              fontSize: 24
            },
            data: legendData
        },
        //calculable : true,
        series : [
            {
              type:'pie',
              radius: ['38%', '55%'],
              center : ['55%', '40%'],
              //roseType : 'area',
              data: sdata
            }
        ]
      };
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/xiayan/device/DeviceMaintainFault.vue